<template>
	<div
		class="modal-inventory-status modal-container"
		:style="{ zIndex: '9999999999' }"
	>
		<div class="modal-header">Inventory Status</div>

		<div
			class="modal-body"
			style="width: 100%"
			:style="$grid('1')"
			v-if="statuses?.length > 0"
		>
			<div :style="$grid('1')">
				<h3>Main Vehicle</h3>
				<div
					:style="$grid('2-2-1')"
					style="display: flex; justify-content: left; gap: 16%; align-items: center"
				>
					<span><strong>Stock#: </strong>{{ statuses[0].stockNumber }}</span>
					<span><strong>VIN:</strong> {{ statuses[0].vin }}</span>
					<Pill
						:label="DYWVehicleStatus[statuses[0].vehicleStatus]"
						:status="getPillStatus(statuses[0].vehicleStatus)"
					/>
				</div>
			</div>
			<div
				v-if="statuses.length > 1"
				:style="$grid('1')"
			>
				<h3>TradeIns</h3>
				<div
					v-for="(status, $index) in statuses.slice(1)"
					:key="status.vin"
					:style="$grid('2-2-1')"
					style="display: flex; justify-content: left; gap: 16%; align-items: center"
				>
					<span>
						<strong>Stock# - Trade{{ $index }}:</strong>
						{{ status.stockNumber }}
					</span>
					<span><strong>VIN</strong>{{ status.vin }}</span>
					<Pill
						:label="DYWVehicleStatus[status.vehicleStatus]"
						:status="getPillStatus(status.vehicleStatus)"
					/>
				</div>
			</div>
		</div>
		<div
			v-else
			style="display: flex; place-content: center"
		>
			<span><em>There are no statuses...</em></span>
		</div>
		<div class="modal-footer">
			<button
				class="button-unwind"
				@click="$modal.close()"
			>
				Close
			</button>
		</div>
	</div>
</template>
<script lang="ts">
	export interface IModalInventoryStatusProps {
		modal: {
			passedData: {
				statuses: DYWInventoryStatusResponse[];
			};
		};
	}
</script>
<script setup lang="ts">
	import $modal from '@core/services/modal';
	import { DYWInventoryStatusResponse } from '@core/classes/Responses/DYWInventoryStatusResponse';
	import { DYWVehicleStatus } from '@core/classes/SharedEnums';
	import Pill from '@core/components/Pill.vue';
	import { ref } from 'vue';

	const { modal } = defineProps<IModalInventoryStatusProps>();

	const statuses = ref<DYWInventoryStatusResponse[]>(modal.passedData.statuses);

	function getPillStatus(vehicleStatus: DYWVehicleStatus) {
		switch (vehicleStatus) {
			case DYWVehicleStatus.IN_STOCK:
				return 'success';
			case DYWVehicleStatus.GONE_SOLD:
				return 'error';
			case DYWVehicleStatus.UNASSIGNED:
				return 'warning';
			default:
				return 'info';
		}
	}
</script>
<style></style>
